import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { EcgSignalResponse, EcgSignalTransformedResponse } from './type'
import { GET_API_TOKEN, ECG_API_BASE_URL } from '../../constants/apiConstants'

const baseQuery = fetchBaseQuery({
  baseUrl: ECG_API_BASE_URL,
  prepareHeaders(headers, api) {
    let token = () => GET_API_TOKEN()
    headers.set('Authorization', `Bearer ${token()}`)
  },
})


export const RecordedEcgSignalsApi = createApi({
  reducerPath: 'recordedEcgSignals',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getRecordedEcgSignals: builder.query<
    EcgSignalTransformedResponse,
      { patientKey: string; ecgWindowId: string }
    >({
      query: ({ patientKey, ecgWindowId }) =>
        `/api/ecg/snapshot/${patientKey}/window/${ecgWindowId}`,
      transformResponse: (response: EcgSignalResponse): EcgSignalTransformedResponse => ({
        status: response.status,
        signals: response.data.signals,
        frequency: response.data.frequency,
      }),
    }),
  }),
})

export const { useLazyGetRecordedEcgSignalsQuery } = RecordedEcgSignalsApi
